// extracted by mini-css-extract-plugin
export default {"landing-mail":"landing-mail_landing-mail__tnkrU","text":"landing-mail_text__jJhJH","input":"landing-mail_input__4eHfM","next":"landing-mail_next__pNSZ7"};